import { ApiCommerceStandaloneSnapshotV2Schema } from "@bridge-applications/pb-types";
import { z } from "zod";

export const StandaloneOffersSliceSchema = z.object({
    userId: z.string().nullable(),
    snapshot: ApiCommerceStandaloneSnapshotV2Schema.nullable(),
    clockOffsetMs: z.number(),
    loadStatus: z.enum(["idle", "loading", "ready", "disabled", "error"]),
    error: z.string().nullable(),
    /** Display hints only. Eligibility and counts always come from the server. */
    shownKeys: z.array(z.string()),
});
export type StandaloneOffersSlice = z.infer<typeof StandaloneOffersSliceSchema>;
